module.exports = __webpack_public_path__ + "assets/images/BBD2.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/BBD2.png
// module id = 1310
// module chunks = 1